import React from 'react';
import PropTypes from 'prop-types';
import style from './AppStoreLink-style.scss';

const AppStoreLinkReactLazy = React.lazy(() =>
    import(/* webpackChunkName: "AppStoreLink" */ './AppStoreLink')
);

const AppStoreLinkPlaceholder = () => <div className={style.placeholder} />;

const AppStoreLinkLazy = props => {
    const { link, isClient } = props;

    return isClient ? (
        <React.Suspense fallback={<AppStoreLinkPlaceholder />}>
            <AppStoreLinkReactLazy link={link} />
        </React.Suspense>
    ) : (
        <AppStoreLinkPlaceholder />
    );
};

AppStoreLinkLazy.propTypes = {
    link: PropTypes.object.isRequired,
    isClient: PropTypes.bool,
};

export default AppStoreLinkLazy;
